const feature = [
    {
        id: 1,
        name: "Download Our App",
        description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit",
        linkName: "Learn More"
    },
    {
        id: 2,
        name: "Create A Free Account",
        description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit",
        linkName: "Learn More"
    },
    {
        id: 3,
        name: "Now Start Your Journey",
        description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit",
        linkName: "Learn More"
    },
]

export default feature